import React, { useState, useCallback } from 'react'
import { Steps } from 'antd'

const { Step } = Steps

const Wizard = ({
  stepMap,
  sectionMap,
  initialStepName,
  initialState = {},
  onComplete,
  onBacktrack,
}) => {
  const [currentStepName, setCurrentStepName] = useState(initialStepName)

  const {
    nextStep,
    nextStepName,
    previousStep,
    Component,
    componentProps = {},
    showProgressTracker = true,
    contentClassName,
  } = stepMap[currentStepName]

  // Setup internal wizardState with key for each step
  const [wizardState, setWizardState] = useState(Object.keys(stepMap).reduce((acc, currentKey) => {
    acc[currentKey] = { ...initialState[currentKey] }
    return acc
  }, {}))

  const handleNextStep = useCallback(async () => {
    const nextStepName = typeof nextStep === 'function'
      ? nextStep({ wizardState, currentStepName })
      : nextStep

    if (nextStepName) {
      setCurrentStepName(nextStepName)
    } else {
      onComplete()
    }
  }, [setCurrentStepName, nextStep, currentStepName, wizardState, onComplete])

  const handlePreviousStep = useCallback(async () => {
    const previousStepName = typeof previousStep === 'function'
      ? previousStep({ wizardState, currentStepName })
      : previousStep

    if (previousStepName) {
      setCurrentStepName(previousStepName)
    } else {
      onBacktrack()
    }
  }, [setCurrentStepName, previousStep, currentStepName, wizardState, onBacktrack])

  const ProgressTracker = () => {
    const currentStep = sectionMap.indexOf(sectionMap.find(({ steps }) => steps.includes(currentStepName)))
    return (
      <Steps size='small' current={currentStep}>
        {sectionMap.map(({ header }) => <Step key={header} title={header} />)}
      </Steps>
    )
  }

  return (
    <div className={contentClassName}>
      {showProgressTracker && <ProgressTracker/>}
      <Component
        goToNextStep={handleNextStep}
        nextStepName={nextStepName}
        goToPreviousStep={handlePreviousStep}
        setWizardState={setWizardState}
        stepName={currentStepName}
        stepState={wizardState[currentStepName]}
        onComplete={onComplete}
        {...componentProps}
      />
    </div>
  )
}

export default Wizard
